export default "__VITE_ASSET__DCGbjx9Y__"